import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, DatePicker, InputNumber,} from 'antd';
import { useShangpindingdanUpdateQuery,useShangpindingdanUpdateSaveMutation,} from '../../store/dianshangtaizhangApi';
import FirmSelect from '../firm/FirmSelect';
import dayjs from 'dayjs'
import FirmUserSelect from '../firmUser/FirmUserSelect';
import GoodsSpecSelect from '../goodsSpec/GoodsSpecSelect';
import { EditOutlined } from '@ant-design/icons';
function GoodsOrderEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        spdd_content:''
    }); 
    const {data,isSuccess} = useShangpindingdanUpdateQuery({spdd_id:props.spdd_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    spdd_sp_name:data.Result.spdd_sp_name,
                    spdd_qy_name:data.Result.spdd_qy_name,
                    spdd_spgg_name:data.Result.spdd_spgg_name,
                    spdd_jiaofei_date:dayjs(data.Result.spdd_jiaofei_date),
                    spdd_jieshu_date:dayjs(data.Result.spdd_jieshu_date),
                    spdd_content:data.Result.spdd_content,
                    spdd_yonghushu:data.Result.spdd_yonghushu,
                    spdd_spgg_price:data.Result.spdd_spgg_price,
                    spdd_gly_id:data.Result.spdd_gly_name,
                    spdd_state:data.Result.spdd_state,
                })
                setInfo(prevState=>({...prevState,                  
                    spdd_gly_name:data.Result.spdd_gly_name,
                    spdd_gly_phone:data.Result.spdd_gly_phone,
                    spdd_gly_id:data.Result.spdd_gly_id,                  
                    spdd_content:data.Result.spdd_content,      
                    spdd_jiaofei_date:data.Result.spdd_jiaofei_date,      
                    spdd_jieshu_date:data.Result.spdd_jieshu_date,      
                    spdd_qy_id:data.Result.spdd_qy_id,      
                    spdd_qy_name:data.Result.spdd_qy_name,                            
                    spdd_spgg_price:data.Result.spdd_spgg_price,    
                    spdd_yonghushu:data.Result.spdd_yonghushu,    
                    spdd_uid:JSON.parse(localStorage.getItem('eu_id')),
                    spdd_uname:JSON.parse(localStorage.getItem('eu_name')),  
                    spdd_sp_id:data.Result.spdd_sp_id,
                    spdd_sp_name:data.Result.spdd_sp_name,
                    spdd_spgg_id:data.Result.spdd_spgg_id,
                    spdd_spgg_name:data.Result.spdd_spgg_name,
                    spdd_state:data.Result.spdd_state,
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useShangpindingdanUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined />修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改商品订单'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        // "spdd_gly_id" : info.spdd_gly_id,
                        // "spdd_gly_name" : info.spdd_gly_name,
                        // "spdd_gly_phone" : info.spdd_gly_phone,                      
                        // "spdd_id" : props.spdd_id,
                        // "spdd_jiaofei_date" : info.spdd_jiaofei_date,
                        // "spdd_jieshu_date" : info.spdd_jieshu_date,
                        // "spdd_qy_id" : info.spdd_qy_id,
                        // "spdd_qy_name" : info.spdd_qy_name,
                        // "spdd_spgg_price" : info.spdd_spgg_price,
                        // "spdd_yonghushu" : info.spdd_yonghushu,
                        // "spdd_content" : info.spdd_content,
                        // spdd_uid:JSON.parse(localStorage.getItem('eu_id')),
                        // spdd_uname:JSON.parse(localStorage.getItem('eu_name')),  
                        'spdd_spgg_price': info.spdd_spgg_price,
                        'spdd_qy_id': info.spdd_qy_id,
                        'spdd_qy_name': info.spdd_qy_name,
                        'spdd_jiaofei_date': info.spdd_jiaofei_date,
                        'spdd_jieshu_date': info.spdd_jieshu_date,
                        'spdd_id': props.spdd_id,
                        'spdd_uid': localStorage.getItem('eu_id'),
                        'spdd_uname': localStorage.getItem('eu_name'),
                        'spdd_content': info.spdd_content,
                        'spdd_yonghushu': info.spdd_spgg_price,
                        'spdd_sp_id': info.spdd_sp_id,
                        'spdd_sp_name': info.spdd_sp_name,
                        'spdd_spgg_id': info.spdd_spgg_id,
                        'spdd_spgg_name': info.spdd_spgg_name,
                        'spdd_state': info.spdd_state,
                        'spdd_gly_id': info.spdd_gly_id,
                        'spdd_gly_name': info.spdd_gly_name,
                        'spdd_gly_phone': info.spdd_gly_phone,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    
                    <GoodsSpecSelect
                        label="规格"     
                        nameOne="spdd_sp_name"
                        nameTwo="spdd_spgg_name"
                        required
                        onChangeOne={(e,f,g,h,i,j) => {
                            setInfo(prevState=>({...prevState,spdd_sp_id:e,spdd_sp_name:f,spdd_spgg_id:g,spdd_spgg_name:h,spdd_spgg_price:i,spdd_spgg_day:j}))
                        }}
                        onChangeTwo={(e,f,g,h) => {
                            setInfo(prevState=>({...prevState,spdd_spgg_id:e,spdd_spgg_name:f,spdd_spgg_price:g,spdd_spgg_day:h}))
                        }}
                        defaultId={info.spdd_spgg_name}
                        wrapperCol={{span:10}}
                    />
                    <FirmSelect
                        label="企业"     
                        name="spdd_qy_name"
                        required
                        onChange={(e,f,g,h) => {
                            console.log(e,f,g,h);
                            setInfo(prevState=>({...prevState,spdd_qy_id:e,spdd_qy_name:f,}))
                        }}
                        wrapperCol={{span:10}}
                    /> 
                    <FirmUserSelect
                        label="管理员"  
                        name='spdd_gly_id'                  
                        onChange={(e,f,g,) => {
                            console.log(e,f,g);
                            setInfo(prevState=>({...prevState,spdd_gly_id:e,spdd_gly_name:f,spdd_gly_phone:g}))
                        }}
                        wrapperCol={{span:6}}
                        required
                        qy_id={info.spdd_qy_id}
                    />          
                    <Form.Item name="spdd_jiaofei_date" wrapperCol={{span:10}} required label='缴费日期'>                        
                        <DatePicker onChange={(e) => {
                            if(info.spdd_spgg_day){
                                setInfo(prevState=>({...prevState,spdd_jiaofei_date:dayjs(e).format('YYYY-MM-DD'),spdd_jieshu_date:dayjs(e).add(+info.spdd_spgg_day, 'day').format('YYYY-MM-DD')}))
                            }else{
                                message.error('请先选择商品规格！')
                            }
                    }}/>
                    </Form.Item>     
                    <Form.Item name="spdd_jieshu_date" wrapperCol={{span:10}} required label='结束日期'>                        
                        <DatePicker onChange={(e) => {setInfo(prevState=>({...prevState,spdd_jieshu_date:dayjs(e).format('YYYY-MM-DD')}))}}/>
                    </Form.Item> 
                    <Form.Item name="spdd_spgg_price" wrapperCol={{span:10}} required label='价格'>                        
                        <InputNumber 
                            onChange={(e) => {setInfo(prevState=>({...prevState,spdd_spgg_price:e}))}}
                            min={1}
                            max={100000}
                        />
                    </Form.Item>  
                    <Form.Item name="spdd_state" wrapperCol={{span:10}} required label='状态'>                        
                        <Input onChange={(e) => {setInfo(prevState=>({...prevState,spdd_state:e.target.value}))}}/>
                    </Form.Item> 
                    <Form.Item name="spdd_content" wrapperCol={{span:10}} label='备注'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,spdd_content:e.target.value}))
                        }}/>
                    </Form.Item>                     
                </Form>
            </Modal>
        </>
    )
}

export default GoodsOrderEdit